import { AfterViewInit, ChangeDetectionStrategy, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TrimStringPipe } from './../../../../../../../../../admin/src/app/shared/pipes/trim-string.pipe';
import { NotificationService } from 'projects/shared/services/notification.service';
import { distinctUntilChanged, noop, Subscription, tap } from 'rxjs';
import { Notification } from 'projects/shared/models/interfaces/notification';
import { CommonModule } from '@angular/common';
import { LanguageService } from 'projects/shop/src/app/+shared/services/language.service';
import { AgoOfDatePipe } from './../../../../../../../../../shared/pipes/ago-of-date.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { StoreChangesService } from 'projects/shared/services/store-changes.service';
import { SkeletonModule } from 'primeng/skeleton';
import { AppRoutingModule } from "projects/shop/src/app/app-routing.module";
import { BrowserService } from 'projects/shared/services/browser.service';
import { NotificationSocketService } from 'projects/shop/src/app/+shared/services/notificationSocket.service';
import { RouterModule } from '@angular/router';
import { MessageService } from 'primeng/api';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';

@Component({
  selector: 'app-nav-notifications',
  standalone: true,
  imports: [TrimStringPipe, CommonModule, AgoOfDatePipe, TranslateModule, SkeletonModule, RouterModule, OverlayPanelModule],
  providers: [MessageService],
  templateUrl: './nav-notifications.component.html',
  styleUrl: './nav-notifications.component.scss'
})

export class NavNotificationsComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('notificationOP') notificationOP!: OverlayPanel;

  notifications: Notification[] = [];
  notificationUnreadCount: any = 0;
  arabicLang = false;
  isLoading = true;
  mobileView = false;

  private _subscription = new Subscription();
  constructor(
    private _notificationService: NotificationService,
    private _languageService: LanguageService,
    private _storeChangesService: StoreChangesService,
    private _browserService: BrowserService,
    private _notificationSocketService: NotificationSocketService,
    private _messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.detectLanguage();
    this.getNotificationCount();
    this.listenNotificationSocket();
    this.getCountOfUnreadNotification();
  }

  ngAfterViewInit(): void {
    this._browserService.getWindow()?.addEventListener('scroll', this.closeOnScroll.bind(this), true);
  }

  closeOnScroll() {
    if (this.notificationOP.overlayVisible) this.notificationOP.hide();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (this._browserService.getWindow()) {
      if (window.innerWidth < 769) {
        this.mobileView = true;
      } else {
        this.mobileView = false;
      }
    }
  }

  detectLanguage() {
    this._languageService.arabic.subscribe(
      res => {
        this.arabicLang = res;
      }
    )
  }

  getNotificationCount() {
    this._notificationService.getCountOfUnreadNotifications().pipe(
      tap(
        res => {
          this._storeChangesService.setReadNotificationsCount(res.count);
        }
      )
    ).subscribe(noop);
  }

  getCountOfUnreadNotification() {
    this._storeChangesService.getReadNotificationsCount().pipe(
      tap(
        res => {
          if (res < 100) {
            this.notificationUnreadCount = res;
          } else {
            this.notificationUnreadCount = '99+'
          }
        }
      )
    ).subscribe()
  }

  listenNotificationSocket() {
    this._notificationSocketService.newNotification.pipe(
      tap(
        notification => {
          if (notification.title) {
            this.notificationUnreadCount++;
            notification.createdAt = new Date().toISOString();
            this.notifications.unshift(notification);
            this.notifications.pop();
            if (this._browserService.getLocation()) if (!location.pathname.includes('notification')) this._messageService.add({ severity: 'info', summary: 'Info', detail: 'You Received New Notification', life: 20000 })
          }
        }
      )
    ).subscribe(noop)
  }

  getNotifications() {
    if (this.notifications.length) {
    }
    else {
      this.isLoading = true;
      this._subscription.add(
        this._notificationService.getUserNotifications({ skip: 0, limit: 4 }).pipe(
          tap(
            res => {
              this.notifications = res.data;
              this.isLoading = false;
            }
          )
        ).subscribe(noop)
      )
    }
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
    this._browserService.getWindow()?.removeEventListener('scroll', this.closeOnScroll.bind(this), true);
  }
}
